import React from 'react';

import TableDisplay from './TableDisplay';

import { Data } from '../services/data-manager';
import { Modal } from 'react-bootstrap';
import Moment from 'react-moment';
import moment from 'moment';
import { modesPaiementMobile } from '../config/globales';
import { notifySuccess, notifyDanger } from '../utils';
import Notification from 'react-notify-toast';

class Recharges extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            recharges: [],
            page: 1,
            nbRecharge: 1,
            sizeRecharge: 50,
            recharge: null,
            newRecharge: {
                idUtilisateur: 0,
                montant: 0,
                pays: "",
                commentaire: ""
            },
            showDetail: false,
            showRecharge: false
        };
        this.getRecharges = this.getRecharges.bind(this);
        this.getDetailRecharge = this.getDetailRecharge.bind(this);
        this.showDetailModal = this.showDetailModal.bind(this);
        this.showRechargeModal = this.showRechargeModal.bind(this);
        this.handleInputRecharge = this.handleInputRecharge.bind(this);
        this.handleSubmitRecharge = this.handleSubmitRecharge.bind(this);
    }
    componentDidMount() {
        this.props.isLoading(true);
        this.getRecharges();
    }
    getRecharges(page=0) {
        if (page!==0) {
            this.setState({page: page});
        } else {
            page = this.state.page;
        }
        this.props.isLoading(true);
        new Data()
        .get("Recharge", "1", "utilisateur", "dateCreation DESC", page, this.state.sizeRecharge)
        .then(res => {
            this.setState({recharges: res.rows, nbRecharge: res.count});
            this.props.isLoading(false);
        })
        .catch(err => {
            console.warn("Error : ", err);
            this.props.isLoading(false);
        });
        window.scrollTo(0,0);
    }
    getDetailRecharge(recharge) {
        this.setState({recharge: recharge}, () => {
            this.showDetailModal();
        });
    }
    handleInputRecharge(e) {
        let target = e.target;
        const name = target.name;
        const value = target.value;
        let newRecharge = this.state.newRecharge;
        newRecharge[name] = value;
        this.setState({newRecharge: newRecharge});
    }
    handleSubmitRecharge() {
        this.showRechargeModal(false);
        let newRecharge = this.state.newRecharge;
        newRecharge.idUtilisateur = this.props.auth.utilisateur.id;
        newRecharge.dateCreation = moment().format();
        new Data().add("Recharge", newRecharge)
        .then(res => {
            if (res.id) {
                newRecharge.montant = 0;
                newRecharge.pays = "";
                newRecharge.commentaire = "";
                this.setState({newRecharge: newRecharge});
                notifySuccess("Recharge enregistrée !");
                this.getRecharges(this.state.page);
            } else {
                notifyDanger("L'enregistrement de la recharge à échoué.");
            }
        });
    }
    showDetailModal(show=true) {
        this.setState({showDetail: show});
    }
    showRechargeModal(show=true) {
        this.setState({showRecharge: show});
    }
    cancelRecharge(recharge) {
        window.confirm("Voulez vous vraiment supprimer la recharge "+recharge.idRecharge);
    }
    render() {
        return (
            <div className="container-fluid">
                <Notification options={{top: "100px"}} />
                <div className="row">
                    <div className="col-sm-12 col-md-8 my-3">
                        <h3>Recharges [Page {this.state.page}/{(this.state.nbRecharge===0)?1:Math.ceil(this.state.nbRecharge/this.state.sizeRecharge)}]</h3>
                    </div>
                    <div className="col-sm-12 col-md-4 my-3 text-right">
                        <button className="btn btn-primary" onClick={() => {this.showRechargeModal(true)}}>Ajouter une recharge</button>
                    </div>
                    <div className="col-sm-12 mb-3">
                        <TableDisplay 
                            tableStriped={true}
                            tableHover={true}
                            thead="dark"
                            titles={["ID", "MONTANT", "PAYS", "DATE ET HEURE"]}
                            indices={["id", "montant", "pays", "dateCreation"]}
                            data={this.state.recharges}
                            actions={[
                                {caption: <i className='fa fa-list'></i>, className:"btn btn-sm btn-primary mr-1", onClick:this.getDetailRecharge}
                            ]}
                            withPaging={true}
                            pagingTheme="primary"
                            nb={this.state.nbRecharge}
                            size={this.state.sizeRecharge}
                            current={this.state.page}
                            onChangePage= {this.getRecharges}
                            withFooter={true} />
                    </div>
                </div>
                {(this.state.recharge) &&
                <Modal show={this.state.showDetail} onHide={() => {this.showDetailModal(false)}} className="mt-5">
                    <Modal.Header closeButton>
                        <Modal.Title>
                            Détails de la recharge #{this.state.recharge.id}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="mx-3">
                            <table className="table table-sm">
                                <tbody>
                                    <tr className="row">
                                        <td className="col-sm-5">ID : </td>
                                        <td className="col-sm-7">{this.state.recharge.id}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-sm-5">Pays : </td>
                                        <td className="col-sm-7">{this.state.recharge.beneficiaire}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-sm-5">Montant : </td>
                                        <td className="col-sm-7">{Intl.NumberFormat().format(this.state.recharge.montant)}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-sm-5">Date : </td>
                                        <td className="col-sm-7"><Moment format="DD/MM/YYYY à HH:mm">{this.state.recharge.dateCreation}</Moment></td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-sm-5">Effectuée par : </td>
                                        <td className="col-sm-7">{this.state.recharge.utilisateur.nom} {this.state.recharge.utilisateur.prenom}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-sm-5">Commentaire : </td>
                                        <td className="col-sm-7">{this.state.recharge.commentaire}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </Modal.Body>
                    <Modal.Footer></Modal.Footer>
                </Modal>
                }
                <Modal show={this.state.showRecharge} onHide={() => {this.showRechargeModal(false)}} className="mt-5">
                    <Modal.Header closeButton>
                        <Modal.Title>
                            Nouvelle recharge
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="form-row">
                            <div className="form-group col-md-12">
                                <label htmlFor="pays">Pays</label>
                                <select name="pays" id="pays" value={this.state.newRecharge.pays} className="form-control" onChange={(e) => this.handleInputRecharge(e)} required>
                                    <option value=""></option>
                                    {( modesPaiementMobile.sort((a,b) => {
                                        if (a.pays<b.pays) return -1;
                                        if (a.pays>b.pays) return 1;
                                        return 0;
                                    })
                                    .filter((item,pos) => (pos==0 || (item.pays!=modesPaiementMobile[pos-1].pays)))
                                    .map(m => <option value={ m.pays } key={'mode-source-'+m.pays}>{ m.paysLabel }</option> ) )}
                                </select>
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="form-group col-sm-12">
                                <label htmlFor="montant">Montant</label>
                                <input type="number" name="montant" value={this.state.newRecharge.montant} id="montant" className="form-control" onChange={(e) => this.handleInputRecharge(e)} required />
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="form-group col-sm-12">
                                <label htmlFor="commentaire">Commentaire</label>
                                <textarea name="commentaire" value={this.state.newRecharge.commentaire} id="commentaire" className="form-control" onChange={(e) => this.handleInputRecharge(e)} required />
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button className="btn btn-primary" onClick={() =>{this.handleSubmitRecharge()}}>Enregistrer</button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

export default Recharges;